import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {HomeComponent} from './home/home.component';
import { HtmlSafe } from './pipes/html-safe.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderComponent } from './header/header.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { MessageBoxComponent } from './message-box/message-box.component';
import { FooterComponent } from './footer/footer.component';
import { ModalPopUpComponent } from './modal-pop-up/modal-pop-up.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CreateProfileComponent } from './create-profile/create-profile.component';
import { DeleteMessageModalComponent } from './delete-message-modal/delete-message-modal.component';
import { EditContactModalComponent } from './edit-contact-modal/edit-contact-modal.component';
import { CreateAddressComponent } from './create-address/create-address.component';
import { DeleteConfirmPopUpComponent } from './delete-confirm-pop-up/delete-confirm-pop-up.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [
    AppComponent,
    // HomeComponent,
    // HtmlSafe,
    HeaderComponent,
    // LoginComponent,
    // SignupComponent,
    // MessageBoxComponent,
    FooterComponent,
    // ModalPopUpComponent,
    // CreateProfileComponent,
    // DeleteMessageModalComponent,
    // EditContactModalComponent,
    // CreateAddressComponent,
    // DeleteConfirmPopUpComponent,
    // ScheduleComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    // FormsModule,
    // NgbModule,
    // SlickCarouselModule,
    // ReactiveFormsModule,
    // FontAwesomeModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
